import * as React from 'react';
import "./AcceptabilityDashboard.css";
import { connect, Dispatch } from 'react-redux';

import * as Actions from '../actions';
import { AnalyseState } from '../interfaces/state';
import { CoughAnalysisSetComment, OverreadStatusEnum, OverreadStatusIdEnum } from '../../../misc/api/apiTypes';
import { AuditModal } from "../../../auditmodal/components/AuditModal";
import once from 'lodash-es/once';
import { useWebPortalLegacyClient, WebPortalLegacyClientInternal, useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';
import { useHistory } from 'react-router-dom';
import { OnIgnoreEnter } from '../AnalyseApp';
import { CoughAnalysisSetTypeEnum } from '../../../misc/api/CoughAnalysisSetTypes';
import { CoughAnalysisSet } from 'webportalclient';
import { useQuery, Condition as OQueryCondition } from "../../../Components/Query";
import { SendForVisualReviewModalBody, SendForVisualReviewModalBodyForm } from "../../../cough-analysis/SendForVisualReviewModal/SendForVisualReviewModal";
import { InitializeAnalysisSetCommentAsyncAction, InitializeVisualReviewForAnalysisSetAction } from '../actions';
interface AcceptabilityDashboardProps {
    isVisible: boolean;
    primaryAnalysisSetId: string;
    acceptabilityModalVisiblility: boolean;
    selectedAcceptability: OverreadStatusEnum;
    isSubmitting: boolean;
    coughAnalysisSet: CoughAnalysisSet;
    requiresVisualReview: boolean;
    comments: CoughAnalysisSetComment[];
    dispatch?: Dispatch<AnalyseState>;
    errorStatus?: string | undefined;
    blindComments: boolean;
}

export const AcceptabilityDashboard = (props: AcceptabilityDashboardProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();
    const [sendForVisualReviewVisible, setSendForVisualReviewVisible] = React.useState(false);
    const history = useHistory();
    const { refresh } = useQuery();

    const onSubmit = once((audit) => {
        props.dispatch(Actions.AcceptabilitySetAsyncAction.create(legacyClient, history, props.primaryAnalysisSetId, props.selectedAcceptability, audit.Annotation));
    })

    React.useEffect(() => {
        props.dispatch(
            Actions.InitializeCurrentAnalysisSetAsyncAction.create(
                client,
                props.coughAnalysisSet.id
            ))
    }, []);

    const handleSendAnalysisSetForVisualReview = (analysisSetId: string) => {
        setSendForVisualReviewVisible(true);

    }

    const [reviewModalState, setReviewModalState] = React.useState({
        pointTime1: 0,
        pointTime2: 0,
        commentValue: '',
        selectedReplyId: null,
    });

    const handlePointTime1Change = (value) => {
        const numericValue = value ? parseFloat(value) : 0;
        setReviewModalState((prevState) => ({
            ...prevState,
            pointTime1: numericValue,
        }));
    };

    const handlePointTime2Change = (value) => {
        const numericValue = value ? parseFloat(value) : 0;
        setReviewModalState((prevState) => ({
            ...prevState,
            pointTime2: numericValue,
        }));
    };

    const handleCommentChange = (event) => {
        event.persist();
        setReviewModalState((prevState) => ({
            ...prevState,
            commentValue: event.target.value,
        }));
    };

    const handleReplyChange = (event) => {
        event.persist();
        setReviewModalState((prevState) => ({
            ...prevState,
            commentReply: event.target.value,
        }));
    };


    const isCorrectTypeForVisualReview = () => !props.coughAnalysisSet.isLinkedAnalysisSet && (props.coughAnalysisSet.type === CoughAnalysisSetTypeEnum.Analysis || props.coughAnalysisSet.type === CoughAnalysisSetTypeEnum.QualityCheck || props.coughAnalysisSet.type === CoughAnalysisSetTypeEnum.ProjectQualityAssurance || props.coughAnalysisSet.type === CoughAnalysisSetTypeEnum.MonitoringQualityAssurance || props.coughAnalysisSet.type === CoughAnalysisSetTypeEnum.DifficultCougherQualityAssurance || props.coughAnalysisSet.type === CoughAnalysisSetTypeEnum.WeeklyQualityAssurance);

    const canSendForVisualReview = (): boolean => {
        return isCorrectTypeForVisualReview() && (props.coughAnalysisSet.status === OverreadStatusIdEnum.Pending);
    }

    const isVisualReviewRequiredOrComplete = () => {
        if (!props.coughAnalysisSet) return false;

        const { requiresVisualReview, coughAnalysisSet } = props;

        if (coughAnalysisSet.visualReviewAnalystSelectionId === null && coughAnalysisSet.firstComplete !== null) {
            return false;
        }

        if (coughAnalysisSet.visualReviewAnalystSelectionId !== null) {

            switch (coughAnalysisSet.visualReviewAnalystSelectionId) {
                case 0:
                    return false;
                case 1:
                    return false;
                case 2:
                    return true;
                case undefined:
                    return true;
            }
        } else if (requiresVisualReview === true) {
            return true;
        } else {
            return false;
        }
       
    };

    if (props.isVisible) {
        return (
            <>
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="tooltip-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                            <button className="btn btn-success" disabled={props.isSubmitting || isVisualReviewRequiredOrComplete()} onClick={() => { props.dispatch(Actions.ShowAcceptabilityAuditModalAction.create(OverreadStatusEnum.Accepted)) }} onKeyDown={OnIgnoreEnter}>
                                <i className="fa fa-check" aria-hidden="true"></i>  Accept
                            </button>
                            {(props.isSubmitting || isVisualReviewRequiredOrComplete()) && (
                                <span className="tooltip-text">Complete Review before accepting</span>
                            )}
                        </div>&nbsp;
                        <button className="btn btn-warning" disabled={props.isSubmitting} onClick={() => props.dispatch(Actions.AcceptabilitySetAsyncAction.create(legacyClient, history, props.primaryAnalysisSetId, OverreadStatusEnum.Pending))} onKeyDown={OnIgnoreEnter}>
                            <i className="fa fa-circle-o" aria-hidden="true"></i> Pending
                        </button>&nbsp;
                        <button className="btn btn-danger" disabled={props.isSubmitting} onClick={() => { props.dispatch(Actions.ShowAcceptabilityAuditModalAction.create(OverreadStatusEnum.Rejected)) }} onKeyDown={OnIgnoreEnter}>
                            <i className="fa fa-times" aria-hidden="true"></i> Reject
                        </button>
                        &nbsp;
                        {canSendForVisualReview() ?
                            <button className="btn btn-primary" disabled={props.isSubmitting} onClick={() => { handleSendAnalysisSetForVisualReview(props.primaryAnalysisSetId); }} onKeyDown={OnIgnoreEnter}>
                                {props.coughAnalysisSet.visualReviewAnalystSelectionId === 0 || props.coughAnalysisSet.visualReviewAnalystSelectionId === 1 ? "View/Add Review Comments" : "Send For Review" } 
                            </button> : null}
                    </div>
                </div>
                {props.acceptabilityModalVisiblility ?
                    <AuditModal header="Analysis Approval"
                        isSubmitting={props.isSubmitting}
                        onSubmit={onSubmit}
                        onClose={() => props.dispatch(Actions.CloseAcceptabilityAuditModalAction.create())} />
                    : null}
                {sendForVisualReviewVisible ?
                    <SendForVisualReviewModalBody
                        dispatch={props.dispatch}
                        comments={props.comments}
                        blindComments={props.blindComments}
                        coughAnalysisSet={props.coughAnalysisSet}
                        analysisSetId={props.coughAnalysisSet.id}
                        errorStatus={props.errorStatus}
                        modalState={reviewModalState}
                        onPointTime1Change={handlePointTime1Change}
                        onPointTime2Change={handlePointTime2Change}
                        onCommentReplyChange={handleReplyChange}
                        setModalState={setReviewModalState}
                        onCommentChange={handleCommentChange}
                        onClose={() => { setSendForVisualReviewVisible(false); refresh(); }} /> : null}
            </>
        );
    } else {
        return null;
    }
}

function mapStateToProps(state: AnalyseState): AcceptabilityDashboardProps {
    return {
        isVisible: !state.core.isViewOnly,
        primaryAnalysisSetId: state.analysisSet.primaryAnalystSetId,
        acceptabilityModalVisiblility: state.core.isAcceptabilityAuditModalVisible,
        selectedAcceptability: state.core.acceptabilityStatus,
        isSubmitting: state.core.isSubmitting,
        coughAnalysisSet: state.core.coughAnalysisSet,
        requiresVisualReview: state.core.requiresVisualReview,
        comments: state.core.comments,
        blindComments: state.core.blindComments
    } as AcceptabilityDashboardProps;
}

export default connect<AcceptabilityDashboardProps, any, void>(mapStateToProps)(AcceptabilityDashboard);
